import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Smile = function Smile(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 2C6.4878 2 2 6.4878 2 12C2 17.5122 6.4878 22 12 22C17.5122 22 22 17.5122 22 12C22 6.4878 17.5122 2 12 2ZM12 20.7805C7.14634 20.7805 3.21951 16.8293 3.21951 12C3.21951 7.14634 7.17073 3.21951 12 3.21951C16.8293 3.21951 20.7805 7.17073 20.7805 12C20.7805 16.8537 16.8537 20.7805 12 20.7805Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.19534 10.4634C8.73415 10.4634 9.17095 10.0266 9.17095 9.48782C9.17095 8.949 8.73415 8.51221 8.19534 8.51221C7.65652 8.51221 7.21973 8.949 7.21973 9.48782C7.21973 10.0266 7.65652 10.4634 8.19534 10.4634Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.8047 10.4634C16.3435 10.4634 16.7803 10.0266 16.7803 9.48782C16.7803 8.949 16.3435 8.51221 15.8047 8.51221C15.2659 8.51221 14.8291 8.949 14.8291 9.48782C14.8291 10.0266 15.2659 10.4634 15.8047 10.4634Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.7559 12.7317H7.24372C6.92665 12.7317 6.60958 12.878 6.41445 13.1463C6.21933 13.4146 6.17055 13.7317 6.24372 14.0488C6.99982 16.5853 9.36567 18.3414 11.9998 18.3414C14.634 18.3414 16.9998 16.5853 17.7315 14.0488C17.8291 13.7317 17.7559 13.4146 17.5608 13.1463C17.3657 12.9024 17.073 12.7317 16.7559 12.7317ZM10.2925 16.8049C10.7559 16.3902 11.3657 16.1463 11.9998 16.1463C12.634 16.1463 13.2437 16.3902 13.7071 16.7805C13.1706 16.9756 12.6096 17.0975 11.9998 17.0975C11.4145 17.1219 10.8291 17 10.2925 16.8049ZM14.8047 16.1951C14.0974 15.3902 13.073 14.9268 11.9998 14.9268C10.9023 14.9268 9.90226 15.3902 9.19494 16.1951C8.43884 15.6341 7.85348 14.878 7.53641 13.9756H16.4876C16.1462 14.878 15.5608 15.6341 14.8047 16.1951Z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default Smile;